import { listCategories } from '@/services/api/categoryService';
import { Category } from '@/types/categories/category';

export class CategoryView {
  public categories: Category[] = [];
  public total: number = 0;
  public currentPage: number = 1;
  public pageSize: number = 20;

  private updateCallback: () => void;

  constructor(updateCallback: () => void) {
    this.updateCallback = updateCallback;
  }

  public async init() {
    await this.loadCategories();
  }

  public async loadCategories(params?: {
    page?: number;
    page_size?: number;
    enabled?: boolean;
  }) {
    const response = await listCategories(params);
    if (response.success && response.data) {
      this.categories = response.data;
      this.total = response.found || 0;
      this.currentPage = response.current_page || 1;
      this.pageSize = response.page_size || 20;
      this.updateCallback();
    }
  }

  public async refresh() {
    await this.loadCategories();
  }

  public addCategory(category: Category) {
    this.categories = [...this.categories, category];
    this.updateCallback();
  }

  public updateCategory(updatedCategory: Category) {
    this.categories = this.categories.map(cat =>
      cat.id === updatedCategory.id ? updatedCategory : cat,
    );
    this.updateCallback();
  }

  public removeCategory(categoryId: number) {
    this.categories = this.categories.filter(cat => cat.id !== categoryId);
    this.updateCallback();
  }
}
